























































































































import Vue from 'vue';
import {
  AsyncBtn,
  notify,
} from 'mycorems-app-shared';
import { AccountType, login } from 'mycorems-app-accounts';
import { SelectLocation } from 'mycorems-app-billing';
import RouterLink from '@/routing/RouterLink.vue';
import InfoIcon from '@/components/InfoIcon.vue';
import register, { Account, User } from '.';

interface Data {
  account: Account,
  user: User,
  task: Promise<void>|null,
  AccountType,
  passwordType: string,
  agreedToTerms: boolean,
}

export default Vue.extend({
  components: {
    AsyncBtn,
    SelectLocation,
    RouterLink,
    InfoIcon,
  },
  data(): Data {
    return {
      account: {
        type: AccountType.COMPANY,
        name: '',
        locationId: null,
      },
      user: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
      },
      task: null,
      AccountType,
      passwordType: 'password',
      agreedToTerms: false,
    };
  },
  computed: {
    passwordTypeIcon(): string {
      return (this.passwordType === 'password') ? 'fa fa-eye' : 'fas fa-eye-slash';
    },
    areDetailsValid(): boolean {
      return (
        this.account.name !== '' && this.user.firstName !== ''
        && this.user.lastName !== '' && this.user.email !== ''
        && this.user.password !== '' && this.account.locationId !== null
        && this.agreedToTerms
      );
    },
  },
  methods: {
    togglePasswordType(): void {
      if (this.passwordType === 'text') {
        this.passwordType = 'password';
      } else {
        this.passwordType = 'text';
      }
    },
    selectLocation(locationId: string): void {
      this.account.locationId = locationId;
    },
    register() {
      this.task = register(this.account, this.user);
      this.task.then(() => {
        notify.success('Thank you for registering.');
        this.login();
      });
    },
    login() {
      this.task = login(this.user.email, this.user.password, false);
      this.task.then(() => {
        this.$router.push('/');
      });
    },
  },
});
